import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Link } from 'react-router-dom';
import { PROFFIT_SEARCH_MY_PAGE_MAIN_BANNER_PC, PROFFIT_SEARCH_MY_PAGE_SIDE_BANNER, } from '../../../../../../define/consts/assets';
import Image from '../../../../../Ui/Common/Image';
/**
 * Proffit Searchのバナーを表示する
 * @returns {JSX.Element}
 * @constructor
 */
const ProfessionalMyPageTopProffitSearchMainBanner = () => {
    // TODO: しばらくはLPへの導線を非表示にする
    const disabled = true;
    if (disabled) {
        return null;
    }
    return (_jsxs(Link, Object.assign({ className: 'professional_mypage_top_proffit_search_main_banner', target: '_blank', to: '/proffit_search/lp' }, { children: [_jsx("div", Object.assign({ className: 'sm-is-dnone' }, { children: _jsx(Image, { alt: '', className: 'banner_pc', isObjectFit: true, src: PROFFIT_SEARCH_MY_PAGE_MAIN_BANNER_PC, useImage: true }) })), _jsx("div", Object.assign({ className: 'sm-is-show' }, { children: _jsx(Image, { alt: '', className: 'banner_sp', isObjectFit: true, src: PROFFIT_SEARCH_MY_PAGE_SIDE_BANNER, useImage: true }) }))] })));
};
export default ProfessionalMyPageTopProffitSearchMainBanner;
